/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateVendorTicketDto } from '../../models/update-vendor-ticket-dto';
import { VendorTicketDto } from '../../models/vendor-ticket-dto';

export interface VendorTicketControllerCancel$Params {
  ticketId: string;
      body: UpdateVendorTicketDto
}

export function vendorTicketControllerCancel(http: HttpClient, rootUrl: string, params: VendorTicketControllerCancel$Params, context?: HttpContext): Observable<StrictHttpResponse<VendorTicketDto>> {
  const rb = new RequestBuilder(rootUrl, vendorTicketControllerCancel.PATH, 'patch');
  if (params) {
    rb.path('ticketId', params.ticketId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<VendorTicketDto>;
    })
  );
}

vendorTicketControllerCancel.PATH = '/api/vendor-ticket/{ticketId}';
